import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHandWithCreamGlyphSecondary from './svgs/HandWithCreamGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var handWithCreamGlyph = (props => useIcon(null, SvgHandWithCreamGlyphSecondary, props));

export { handWithCreamGlyph as default };
